/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 18:48:05
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-09-21 16:10:41
 * @Description:路由跳转关闭
 * @FilePath: /src/permission.js
 */
import store from '@/store';
import router from '@/router';
import customerService from '@/components/customerService/index.js';
import loginModel from '@/components/loginModel/index.js';
import picker from '@/components/picker/index.js';
import payType from '@/components/payType';
import util from '@/lib/util';
import {
    QZ_SPECIAL_TOKEN,
    QZ_PLATFORM_ID,
    QZ_SUB_PLATFORM_ID,
    QZ_SCENE_TYPE,
    QZ_CURRENT_SCENE_VALUE,
    QZ_PLATFORM_USER_OPEN_ID,
    QZ_PLATFORM_APP_ID,
    QZ_WX_OPEN_ID,
    QZ_MERCH_ID,
    QZ_PROMOTER_ID,
} from 'constant';
import {
    PAGE_ROOT,
    PAGE_MAIN_MOVIE,
    PAGE_MAIN_CINEMA,
    PAGE_MOVIE_INFO,
    PAGE_CINEMA_INFO,
    PAGE_SET_CITY,
} from 'page';
import { GET_WX_CONFIG } from 'api';

let initializationPromise = null;
let locationInitialized = false;

function requiresLocation(path) {
    return [PAGE_ROOT, PAGE_MAIN_MOVIE, PAGE_MAIN_CINEMA, PAGE_MOVIE_INFO, PAGE_CINEMA_INFO, PAGE_SET_CITY].indexOf(path) > -1;
}

router.beforeEach((to, from, next) => {
    util.clearMyTime();
    store.commit('setWxConfigHref', window.location.href);
    if (to.meta.zhCnName == '') {
        util.setTitleName();
    } else if (store.state.common.title.titleName === '') {
        util.setTitleName();
    }

    if (!store.getters.initialization) {
        if (initializationPromise) {
            initializationPromise.then(next, next);
            closeTransientUi();
            return;
        }
        const query = Object.assign({}, to.query);
        if (query.vConsole && query.vConsole == 'true') {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `${process.env.VUE_APP_BASE_URL}/js/vconsole.min.js`;
            document.body.appendChild(script);
        }
        if (query.specialToken && query.specialToken === 'true') {
            store.commit('setSpecialToken', true);
        } else {
            store.commit('setSpecialToken', false);
        }
        if (store.getters.specialToken) {
            if (query.platformId) {
                if (query.platformId.indexOf(',') > -1) {
                    query.platformId = query.platformId.split(',');
                }
                if (typeof query.platformId == 'object') {
                    query.platformId = query.platformId[query.platformId.length - 1];
                }
                if (query.platformId) {
                    store.commit('setPlatformId', query.platformId);
                }
            } else if (localStorage.getItem(QZ_PLATFORM_ID)) {
                store.commit('setPlatformId', localStorage.getItem(QZ_PLATFORM_ID));
            }
        }

        let promiseList = [];
        /**
         * 1. 处理需要隐藏的数据，然后刷新页面。 - Start
         */
        // 存储token
        var isReload = false;
        if (query.token) {
            isReload = true;
            localStorage.setItem(store.getters.currentTokenKey, query.token);
            delete query.token;
        }
        // 存储wxOpenId
        if (query.wxOpenId) {
            isReload = true;
            localStorage.setItem(QZ_WX_OPEN_ID, query.wxOpenId);
            delete query.wxOpenId;
        }
        // 刷新页面
        if (isReload) {
            next({ path: to.path, query, replace: true });
            closeTransientUi();
            return;
        }
        /**
         * 1. - End
         */

        /**
         * 2. 处理需要请求的数据 - Start
         */
        // 渠道id
        if (query.platformId) {
            if (query.platformId.indexOf(',') > -1) {
                query.platformId = query.platformId.split(',');
            }
            if (typeof query.platformId == 'object') {
                query.platformId = query.platformId[query.platformId.length - 1];
            }
            if (query.platformId) {
                promiseList.push({
                    name: 'platformId',
                    request: util.getPlatformInfo,
                });
                store.commit('setPlatformId', query.platformId);
            }
        } else if (localStorage.getItem(QZ_PLATFORM_ID)) {
            promiseList.push({
                name: 'platformId',
                request: util.getPlatformInfo,
            });
            store.commit('setPlatformId', localStorage.getItem(QZ_PLATFORM_ID));
        }
        // 设置token
        if (localStorage.getItem(store.getters.currentTokenKey)) {
            promiseList.push({
                name: 'token',
                request: util.getUserInfo,
            });
            store.commit('setToken', localStorage.getItem(store.getters.currentTokenKey));
        }
        // 仅依赖城市和距离的页面获取定位。
        if (requiresLocation(to.path)) {
            let getLocationData = {};
            if (query.lat && query.lng) {
                getLocationData.presetLocation = {
                    lat: query.lat,
                    lng: query.lng,
                };
            }
            promiseList.push({
                name: 'getLocation',
                request: () => util.getLocation(getLocationData),
            });
            locationInitialized = true;
        }
        // 设置环境场景值
        if (query.currentScene) {
            store.commit('setSceneType', 1);
            store.commit('setCurrentScene', query.currentScene);
        } else {
            var sceneType = window.localStorage.getItem(QZ_SCENE_TYPE) || 0;
            var currentScene = window.localStorage.getItem(QZ_CURRENT_SCENE_VALUE);
            if (sceneType == 1 && currentScene) {
                store.commit('setSceneType', 1);
                store.commit('setCurrentScene', currentScene);
            } else {
                promiseList.push({
                    name: 'currentScene',
                    request: util.setCurrentScene,
                });
            }
        }
        initializationPromise = Promise.all(
            promiseList.map(v => {
                console.log(v.name);
                return v.request();
            })
        ).then(([...promiseResList]) => {
            let afterInitialization = Promise.resolve();
            for (let i = 0; i < promiseList.length; i++) {
                const promiseItem = promiseList[i];
                const promiseResItem = promiseResList[i];
                console.log(promiseItem.name, promiseResItem);
                switch (promiseItem.name) {
                    case 'currentScene':
                        if (store.getters.isWechatBrowser) {
                            // 初始化wx.config
                            afterInitialization = util.post(GET_WX_CONFIG, {
                                url: store.state.common.wxConfigHref,
                            }).then(res => {
                                if (res.success) {
                                    let config = Object.assign(res.data, {
                                        debug: false,
                                        jsApiList: [
                                            'chooseWXPay',
                                            'getLocation',
                                            'updateAppMessageShareData',
                                            'updateTimelineShareData',
                                            'onMenuShareTimeline',
                                            'onMenuShareAppMessage',
                                        ],
                                    });
                                    wx.config(config);
                                    wx.ready(function () {
                                        console.log('注册成功');
                                    });
                                    wx.error(function (res) {
                                        console.error('注册失败', res);
                                    });
                                }
                            });
                        }
                        break;

                    default:
                        break;
                }
            }
            return afterInitialization;
        }).catch(error => {
            console.error('permission', 'initialization', error);
            store.commit('setConfigError', {
                platformId: store.state.common.platformId,
                message: '',
            });
        }).then(() => {
            store.commit('setInitialization', true);
            initializationPromise = null;
            next();
        });

        // 初始化超时处理，避免长时间白屏
        setTimeout(() => {
            if (!store.getters.initialization) {
                console.error('permission', 'initialization timeout');
                store.commit('setConfigError', {
                    platformId: store.state.common.platformId,
                    message: '加载超时',
                });
                store.commit('setInitialization', true);
                initializationPromise = null;
                next();
            }
        }, 15000);
        /**
         * 2. - End
         */

        // 子渠道id
        if (query.subPlatformId) {
            store.commit('setSubPlatformId', query.subPlatformId);
        } else if (localStorage.getItem(QZ_SUB_PLATFORM_ID)) {
            store.commit('setSubPlatformId', localStorage.getItem(QZ_SUB_PLATFORM_ID));
        }
        // merchId promoterId
        if (query.merchId) {
            store.commit('setMerchId', query.merchId);
        } else if (localStorage.getItem(QZ_MERCH_ID)) {
            store.commit('setMerchId', localStorage.getItem(QZ_MERCH_ID));
        }
        // promoterId
        if (query.promoterId) {
            store.commit('setPromoterId', query.promoterId);
        } else if (localStorage.getItem(QZ_PROMOTER_ID)) {
            store.commit('setPromoterId', localStorage.getItem(QZ_PROMOTER_ID));
        }
        // closeWindow
        if (query.closeWindowType) {
            store.commit('setCloseWindowType', query.closeWindowType);
        }
        // 同步标题
        if (query.titleName) {
            util.setTitleName(decodeURIComponent(query.titleName));
        }
        // 同步第三方openId
        if (query.openId) {
            store.commit('setPlatformUserOpenId', query.openId);
        } else if (localStorage.getItem(QZ_PLATFORM_USER_OPEN_ID)) {
            store.commit('setPlatformUserOpenId', localStorage.getItem(QZ_PLATFORM_USER_OPEN_ID));
        }
        // 同步第三方appId
        if (query.appId) {
            store.commit('setPlatformAppId', query.appId);
        } else if (localStorage.getItem(QZ_PLATFORM_APP_ID)) {
            store.commit('setPlatformAppId', localStorage.getItem(QZ_PLATFORM_APP_ID));
        }
        // 设置wxOpenId
        if (localStorage.getItem(QZ_WX_OPEN_ID)) {
            store.commit('setWxOpenId', localStorage.getItem(QZ_WX_OPEN_ID));
        }
        /**
         * 3. - End
         */
    } else {
        if (requiresLocation(to.path) && !locationInitialized) {
            locationInitialized = true;
            util.getLocation().then(next, next);
        } else {
            next();
        }
    }

    closeTransientUi();
});

function closeTransientUi() {
    util.unlockScreen({ _top: 0 });
    customerService.close();
    loginModel.close();
    picker.close();
    payType.close();
}
